import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";
@Pipe({
  name: "dateformat"
})
export class DateformatPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    const resultDate = new Date(value);
    return moment(resultDate).format("D / MM / YYYY");
    // return (resultDate.getUTCDate() + 1) + " / " + (resultDate.getMonth() + 1) + " / " + resultDate.getFullYear();
  }

}
